import React, { useState } from 'react';
import validIcon from "../../assets/images/register/green_check.svg";

const CareersRegisterInputName = (props) => {
    const { name, values, setFieldValue, validationSchema, errors, touched, handleBlur } = props;
    const signupUrlCheck = () => {
        let isUrl = false;
        if (window.location.pathname.includes("/user/register")) {
            isUrl = true;
        }
        return isUrl;
    }
    const handleChange = (e, name) => {
        let value = e.target.value;
        if (name == "studentname" || name == "name") {
            const prevValue = values[name] ?? '';
            if (value.startsWith('.') || !/^[a-zA-Z.” “\s]*$/.test(value) || value?.length > 60) {
                setFieldValue(name, prevValue);
                if (signupUrlCheck()) {
                    props.setSyncSignupValues((prev) => ({ ...prev, [name]: prevValue }))
                }
                value = prevValue;
                return;
            }
            else {
                const validateValue = value?.trimStart()?.replace(/\s+/g, ' ')?.replace(/\.+/g, '.')?.replace(/\.\s\./g, '. ');
                setFieldValue(name, validateValue);
                if (signupUrlCheck) {
                    props.setSyncSignupValues((prev) => ({ ...prev, [name]: validateValue }))
                }
                value = validateValue
            }
        }
    };

    return (
        <div className={errors?.[name] && touched?.[name] ? "careers_register_form_card text_input invalid_field" : values?.[name] ? "careers_register_form_card text_input white_bg" : "careers_register_form_card text_input"}>
            <input type="text"
                name={name} className="input_type_text"
                onBlur={(e) => { handleBlur(e), props.updateTouchedFields({ ...touched, [`${name}`]: true }) }}
                value={values?.[name]}
                onChange={(e) => { handleChange(e, name) }}
                id="name_focus"
            />
            <span className={values?.[name] ? 'floating_label_active' : 'floating_label'}>{props.placeholder}</span>
            {!errors?.[name] && values?.[name] && (values?.[name].trim()?.length >= 2 && values?.[name].trim()?.length <= 60) && <img src={validIcon} alt="careers_register_checkIcon" className='careers_register_valid_icon' />}
            {errors?.[name] && touched?.[name] && (
                <div className="invalid_card">
                    <span className="invalid_card_text">{errors?.[name]}</span>
                </div>
            )}
        </div>
    )
}

export default CareersRegisterInputName;